import React from 'react';

import './style.scss';

class Checkbox extends React.Component {
  state = {
    isChecked: false,
  };

  handleChange = () => {
    const { label, value } = this.props;
    const { isChecked } = this.state;
    this.setState({
      isChecked: !isChecked,
    });

    if (this.props.onChange) {
      this.props.onChange({
        label,
        value,
        isChecked: !isChecked,
      });
    }
  };

  render() {
    const { label, value } = this.props;
    const { isChecked } = this.state;

    return (
      <div className="assessment__checkbox">
        <label>
          <input
            type="checkbox"
            checked={isChecked}
            value={value}
            onChange={this.handleChange}
          />
          {label}
        </label>
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/routes/assessment/components/Checkbox/index.js